<template>
    <md-table v-model="orderAttachmentsList" :md-fixed-header="!!orderAttachmentsList && orderAttachmentsList.length > 0" :style="hiddenOverflowWhenEmpty" ref="orderAttachmentsList">
        <md-table-toolbar>
            <div class="md-toolbar-section-start">
                <h1 class="md-title">{{ $t('views.order.common.table.attachments.label') }}</h1>
            </div>
            <div class="md-toolbar-section-end">
                <md-button :class="orderAttachmentsList.length > 0 ? 'md-subtitle-btn disabled' : 'md-subtitle-btn'" v-if="allowAddAttachment" :disabled="orderAttachmentsList.length > 0 || orderId === undefined" @click="addAttachmentHandler">
                    {{ $t('views.order.common.table.attachments.addAtachment') }}
                </md-button>
            </div>
            <span v-if="orderAttachmentsList.length > 0 && allowAddAttachment" class="md-caption">
              {{ $t('views.order.common.table.attachments.validation.length') }}
            </span>
        </md-table-toolbar>
        <md-table-row slot="md-table-row" slot-scope="{ item, index }"
          @mouseover="attachmentCurrentHoverIndex = index"
          @mouseleave="attachmentCurrentHoverIndex = null"
          @dblclick="openAttachment(item.id, item.name)">
            <md-table-cell :md-label="$t('views.order.common.table.attachments.name')">
                {{ item.name }}
            </md-table-cell>
            <div class="actions" v-if="attachmentCurrentHoverIndex === index">
              <md-button class="md-icon-button" @click="sendAgainAttachment(item.id)" v-if="!draft">
                <md-icon>refresh</md-icon>
                <md-tooltip md-direction="top">{{ $t('refreshAttachment') }}</md-tooltip>
              </md-button>
              <md-button class="md-icon-button" @click="openAttachment(item.id, item.name)">
                <md-icon>save</md-icon>
                <md-tooltip md-direction="top">{{ $t('save') }}</md-tooltip>
              </md-button>
              <md-button class="md-icon-button" @click="deleteAttachment(item.id, index)" v-if="allowAddAttachment">
                <md-icon>delete</md-icon>
                <md-tooltip md-direction="top">{{ $t('delete') }}</md-tooltip>
              </md-button>
            </div>
        </md-table-row>
        <md-table-empty-state class="md-layout-item md-size-100" :md-label="$t('dialog.noData')" />
    </md-table>
</template>

<script>
import {orderAttachmentsEndpoint} from '@/services/adsign-backend/endpoints';

export default {
    name: 'OrderAtachmentsTable',
    props: {
        value: {
            type: Array,
            default: undefined
        },
        addAttachmentHandler: {
            type: Function,
            default: null
        },
        allowAddAttachment: {
            type: Boolean,
            default: true
        },
        campaignId: {
            type: [String, Number],
            default: undefined
        },
        orderId: {
            type: [String, Number],
            default: null
        },
        draft: {
                type: Boolean,
                default: true
        }
    },
    computed: {
        hiddenOverflowWhenEmpty() {
            if (!this.orderAttachmentsList || this.orderAttachmentsList.length == 0) {
                return ({
                    overflow: 'hidden'
                });
            }
            return {};
        }
    },
    data() { return {
        attachmentCurrentHoverIndex: null,
        orderAttachmentsList: this.value || []
    }},
    methods: {
        openAttachment(attachmentId, attachmentName){
          orderAttachmentsEndpoint.openOrderAttachment(this.orderId, attachmentId).then(result => {
            let blob = new Blob([result], { responseType: 'blob' })
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', attachmentName);
            document.body.appendChild(link);
            link.click();
          })
        },
        deleteAttachment(attachmentId, index) {
            orderAttachmentsEndpoint.deleteOrderAttachment(this.orderId, attachmentId)
                .then(() => {
                    this.orderAttachmentsList.splice(index, 1);
                });
        },
        sendAgainAttachment(attachmentId){
            orderAttachmentsEndpoint.resendOrderAttachment(this.orderId, attachmentId)
                .then(() => {
                    this.$router.go()
                })
        }
    },
    mounted() {
        this.$watch(() => this.value, newValue => {
            this.orderAttachmentsList = newValue;
        });
    }
}
</script>

<style scoped lang="scss">
@import "~vue-material/dist/theme/engine";

.disabled{
  color: #9EA0A8 !important;
  border: 1px solid #9EA0A8;
}

.md-caption {
    color: md-get-palette-color(red, A200);
}

</style>